// third party libraries
import React, { useContext, useEffect, useMemo, useState, lazy, Suspense } from 'react'
import { useTranslation } from 'react-i18next'
// utils
import { Container, StyledHeader } from './styled'
import { tableColumns } from './consts'
// custom components
import { useQuery } from 'components/graphql'
import { RestaurantContext } from '../../RestaurantDesignerHandler'
import { ContentBlockLoading, ExpandableBlocks } from 'components/ContentBlock'
import { Select } from 'components/forms'

// gql queries
import { listRestaurantOpenedTables } from '../../queries'
import { getBranchList } from '../../queries'

// lazy components
const DxDataTable = lazy(() => import('components/DxDataTable'))

const TableState = () => {
	const [currentShop, setCurrentShop] = useState(null)
	const { currentProjectIds: { projectId } } = useContext(RestaurantContext) || {}

	const { data, loading, error } = useQuery(listRestaurantOpenedTables, {
		skip: !currentShop || !projectId,
		variables: {
			projectId: +projectId,
			shopId: currentShop
		}
	})

	const response = useQuery(getBranchList)
	const [t] = useTranslation()

	const shopList = useMemo(() => {
		const { data: shopData, loading: shopLoading, error: shopError } = response
		if (!shopLoading && !shopError) {
			let result = []
			const { clientTree = [] } = shopData
			clientTree.forEach(({ regions }) => {
				regions.forEach(({ shops }) => {
					result.push(...shops.map((s) => ({ label: s.name, value: +s.id }))) // eslint-disable-line
				})
			})
			return result
		}
		return []
	}, [response.data])

	useEffect(() => {
		shopList?.[0] && setCurrentShop(shopList[0].value)
	}, [shopList])

	return (
		<Container>
			{error && <small style={{ color: 'red' }}>{error}</small>}
			<ExpandableBlocks>
				<ContentBlockLoading
					isLoading={loading}
					topBorder
					label={t('restaurant_designer_section.strings.table_state_title')}
				>
					<StyledHeader>
						<Select
							value={currentShop}
							label={t('common.strings.branch')}
							options={shopList}
							disabled={error}
							onChange={(option) => setCurrentShop(option.value)}
							style={{ marginBottom: 10 }}
						/>
						{/* <Button
							status='green'
							style={{ marginLeft: 18, maxWidth: 200 }}
							onClick={() => fetchData({ variables: { projectId: +projectId, shopId: currentShop } })}
							text={t('restaurant_designer_section.strings.refresh_table')} /> */}
					</StyledHeader>
					<Suspense fallback={'...'}>
						<DxDataTable
							data={data?.listRestaurantOpenedTables || []}
							columns={tableColumns(t)}
							columnAutoWidth
							withSearch
						/>
					</Suspense>
				</ContentBlockLoading>
			</ExpandableBlocks>
		</Container>
	)
}

export default TableState
